import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';

function LinkRenderer(props: any) {
	return (
		<a href={props.href} target="_blank" rel="noreferrer" className="cookiesLink">
			{props.children}
		</a>
	);
}

const sanitizeSchema = {
	...defaultSchema,
	tagNames: [
		...(defaultSchema.tagNames || []),
		'b',
		'br',
		'u',
		'i',
		'em',
		'strong',
		'ul',
		'ol',
		'li',
	],
};

export const MarkdownRenderer = ({ children }: { children: string | null }) => {
	return (
		<ReactMarkdown
			rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeSchema]]}
			components={{ a: LinkRenderer }}
		>
			{children}
		</ReactMarkdown>
	);
};
